export const CACHE_AND_NETWORK = 'cache-and-network';
export const CACHE_FIRST       = 'cache-first';
export const NETWORK_ONLY = 'network-only';
export const CIDR_V4_RE = /^([0-9]{1,3}\.){3}([0-9]{1,3}\/)([0-9]|[1-2][0-9]|3[0-2])$/


export const G_BUTTON_PROGRESS              = 'G_BUTTON_PROGRESS';
export const G_USERNAME                     = 'G_USERNAME';

export const M_UPDATE_CONTRACTS_VIEW        = 'M_UPDATE_CONTRACTS_VIEW';
export const M_UPDATE_PRINTERS_VIEW         = 'M_UPDATE_PRINTERS_VIEW';
export const M_UPDATE_BIGFOX_NETWORK_VIEW   = 'M_UPDATE_BIGFOX_NETWORK_VIEW';
export const M_UPDATE_BIGFOX_PRINTER_VIEW   = 'M_UPDATE_BIGFOX_PRINTER_VIEW';
export const M_UPDATE_INVOICES_VIEW         = 'M_UPDATE_INVOICES_VIEW';
export const M_SET_CONTRACT_INVOICES_VIEW   = 'M_SET_CONTRACT_INVOICES_VIEW';
export const M_UPDATE_NOW                   = 'M_UPDATE_NOW';
export const M_LOGIN                        = 'M_LOGIN';
export const M_LOGOUT                       = 'M_LOGOUT';
export const M_BUTTON_PROGRESS              = 'M_BUTTON_PROGRESS';
export const M_SET_TITLE                    = 'M_SET_TITLE';
export const M_SET_SUBTITLE                 = 'M_SET_SUBTITLE';

export const A_START_TASK                   = 'A_STAR_TASK';
export const A_LOGOUT                       = 'A_LOGOUT';